import FeaturedTopic from './../featured-topics/FeaturedTopic'
import Search from '../algolia/components/Search'
import InputGroup from '../ui-components/InputGroup'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import Switcher from '../control/Switcher'
import globals from '../../utils/globals'

const SortableList = SortableContainer(({ children }) => <ul className='sortable-curated-topics-list'>{children}</ul>)
const SortableItem = SortableElement(({ children }) => <li className='sortable-curated-topic'>{children}</li>)
const convertFoundTopicToCuratedTopic = (foundTopic) => {
  return {
    id: foundTopic.id,
    title: foundTopic.title,
    url: globals('communityUrl') + foundTopic.topic_url,
    type: foundTopic.content_type
  }
}

const ContentCurationManager = (props) => (
  <div className='content-curation-manager'>
    {
      props.description ? (
        <div className='form-group'>{ props.description }</div>
      ) : null
    }
    {
      props.visibilityText ? (
        <div className='form-group'>
          <label>Visibility</label>
          <div className='content-curation-manager_visibility'>
            <div className='clearfix content-curation-manager_visibility-switch'>
              <Switcher on={props.enabled} label={props.visibilityText}
                onChange={() => props.onUpdate('enabled', !props.enabled)} />
            </div>
            {
              props.showCommunityListVisibility ? (
                <div className='clearfix content-curation-manager_visibility-switch'>
                  <Switcher on={props.enabledCommunityList} label={props.communityListVisibilityText}
                    onChange={() => props.onUpdate('enabledCommunityList', !props.enabledCommunityList)} />
                </div>
              ) : null
            }
          </div>
        </div>
      ) : null
    }
    <InputGroup
      title='Title'
      qaClasses='qa-content-curation-manager_title'
      type='text'
      onChange={(e) => props.onUpdate('title', e.target.value)}
      value={props.title} />
    <div className='form-group'>
      <label>Topics</label>
      <SortableList
        useDragHandle
        onSortEnd={(result) => props.onUpdate('curatedTopics',
          arrayMove(props.curatedTopics, result.oldIndex, result.newIndex))}
      >
        {props.curatedTopics.map(
          (curatedTopic, idx) => <SortableItem index={idx}
            key={curatedTopic.id}>
            <FeaturedTopic
              title={curatedTopic.title}
              url={curatedTopic.url}
              onDelete={() => props.onUpdate('curatedTopics',
                props.curatedTopics.filter(t => t !== curatedTopic))} />
          </SortableItem>)}
        <Search
          isControl
          searchPlaceholder={props.searchPlaceholder}
          callback={foundTopic => props.onUpdate('curatedTopics',
            props.curatedTopics.concat(
              [convertFoundTopicToCuratedTopic(foundTopic)]))}
          exclude={props.curatedTopics.map(t => t.id)}
          submitIconType='add'
        />
      </SortableList>
    </div>
  </div>
)

export default ContentCurationManager
